import { Store } from 'vuex';

import { loadAccountFeatureToggleSubscriptions } from '@accountFederation/utils/loadAccountFeatureToggleSubscriptions';
import { initializeGamingFederation } from '@gamingFederation/initializeGaming';
import { initializeSocial } from '@socialFederation/initializeSocial';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { initializeShops } from '@src/federations/shops/initializeShops';
import { trackSportOfferExperiments } from '@store/modules/ui/sportOffer/experiment/init';
import { initializeTicketsFederation } from '@ticketFederation/initializeTickets';
import { trackBetBuilderFeatureFlags } from '@sportOfferFederation/bet-builder/init/trackBetBuilderFeatureFlags';
import { initializeWalletFederation } from '@walletFederation/initializeWallet';
import { initializeAccountFederation } from '@accountFederation/initializeAccount';
import { addFederationRoutes } from './router';
import { homepageRouteConfig } from './router/routes/homepageRoute';
import { NavigationContext } from '@superbet-group/web.types';

export function onAppInit(store: Store<unknown>): Promise<unknown> {
    const shouldInitialize: Promise<unknown>[] = [];

    addFederationRoutes(
        [homepageRouteConfig],
        undefined,
        shellLocalConfig.hasSportsFederation ? NavigationContext.Sports : NavigationContext.Casino,
    );

    if (shellLocalConfig.hasFeatureToggleService) {
        shouldInitialize.push(loadAccountFeatureToggleSubscriptions(store));
        shouldInitialize.push(trackSportOfferExperiments(store));
        shouldInitialize.push(trackBetBuilderFeatureFlags(store));
    }
    if (shellLocalConfig.hasGamingFederation) {
        shouldInitialize.push(initializeGamingFederation(store));
    }
    if (shellLocalConfig.hasShopsFederation) {
        shouldInitialize.push(initializeShops());
    }
    if (shellLocalConfig.hasTicketsFederation) {
        shouldInitialize.push(initializeTicketsFederation(store));
    }
    if (shellLocalConfig.hasSocialFederation) {
        shouldInitialize.push(initializeSocial(store));
    }

    shouldInitialize.push(initializeAccountFederation(store));

    // This will be updated once the wallet federation is ready
    shouldInitialize.push(initializeWalletFederation(store));

    return Promise.all(shouldInitialize);
}
